let closeAnnouncement = document.querySelector(".cc__announcement-close");

if( closeAnnouncement ){
    closeAnnouncement.addEventListener('click', function(){
        document.querySelector(".shopify-section-group-header-group").style.display = 'none';
    });
}


const buildSwiperSlider = (sliderElm) => {
	const sliderIdentifier = sliderElm.dataset.swiper;
	return new Swiper(`#${sliderElm.dataset.swiper}`, {
		slidesPerView: "auto",
		spaceBetween: 0,
		navigation: {
			nextEl: `.sp-button-next-${sliderIdentifier}`,
			prevEl: `.sp-button-prev-${sliderIdentifier}`,
		},
	});
};

let swiperFC = document.querySelectorAll(".swipes");

if (swiperFC) {
	swiperFC.forEach((slider) => buildSwiperSlider(slider));
}

const swipeLogo = (sliderElm) => {
	const sliderIdentifier = sliderElm.dataset.swiper;
	return new Swiper(`#${sliderElm.dataset.swiper}`, {
		slidesPerView: 1,
		spaceBetween: 16
	});
};

let SwiperLogo = document.querySelectorAll(".logolists");

if (SwiperLogo) {
	SwiperLogo.forEach((slider) => swipeLogo(slider));
}


let articlefilter = document.querySelectorAll('.cc__main-blog-archive-filter-item');

if( articlefilter.length > 0){
	articlefilter.forEach(af=>{
		af.addEventListener('click', et=>{
			let filter = et.currentTarget.dataset.filter;
			let articlelist = document.querySelector('.cc__main-blog-archive-articles-list');

			fetch(filter)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html"
					);

					articlelist.innerHTML = html.querySelector('.cc__main-blog-archive-articles-list').innerHTML;
				})
				.catch((e) => {
					console.error(e);
				});

			if( document.querySelector('.cc__filter-active') ){
				document.querySelector(".cc__filter-active").classList.remove('cc__filter-active');
			}

			et.currentTarget.classList.add('cc__filter-active');
		});
	})
}

let articlesort = document.querySelector('.cc__main-blog-archive-sort-filter-trigger');

if( articlesort ){
	articlesort.addEventListener('click', et=>{
		et.currentTarget.classList.toggle('cc__activesort');
	});
}


let articleSortItem = document.querySelectorAll('.cc__main-blog-archive-sort-list li');

if(articleSortItem){
	articleSortItem.forEach(asi=>{
		asi.addEventListener('click', et=>{
			let target = et.currentTarget.dataset.sort;
			let articlelist = document.querySelector('.cc__main-blog-archive-articles-list');
	
			if(document.querySelector('.current__sort')){
				document.querySelector('.current__sort').classList.remove('current__sort');
			}
	
			if(target){
				fetch(target)
				.then((response) => response.text())
				.then((responseText) => {
					const html = new DOMParser().parseFromString(
						responseText,
						"text/html"
					);
	
					articlelist.innerHTML = html.querySelector('.cc__main-blog-archive-articles-list').innerHTML;
				})
				.catch((e) => {
					console.error(e);
				});
			}
	
	
	
			et.currentTarget.classList.add('current__sort');
		});
	})
}

let archiveSporsmalBtn = document.querySelectorAll(".cc__image-with-text__faq-title");

var i;

for (i = 0; i < archiveSporsmalBtn.length; i++) {
	archiveSporsmalBtn[i].addEventListener("click", function () {
		var panel = this.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
			this.classList.toggle("archive_faq_open");
		} else {
			let active = document.querySelectorAll(
				".cc__image-with-text__faq .cc__image-with-text__faq-title.archive_faq_open"
			);
			for (let j = 0; j < active.length; j++) {
				active[j].classList.remove("archive_faq_open");
				active[j].nextElementSibling.style.maxHeight = null;
			}

			panel.style.maxHeight = (panel.scrollHeight + 10) + "px";
			this.classList.toggle("archive_faq_open");
		}
	});
}


 const videos = document.querySelectorAll(".cc_video");
 const playBtns = document.querySelectorAll(".cc__grid-video-btn");


  // Loop through each video block
  videos.forEach((video, index) => {
    
    // Add click event listener to play button
    playBtns[index].addEventListener('click', () => {
      togglePlay(video, playBtns[index]);
    });

    // Add click event listener to video
    video.addEventListener('click', () => {
      togglePlay(video, playBtns[index]);
    });

    // Show play button when video paused
    video.addEventListener('pause', () => {
      playBtns[index].style.display = 'flex';
    });

    // Hide play button when video starts playing
    video.addEventListener('play', () => {
      playBtns[index].style.display = 'none';
    });
  });

  // Function to toggle play/pause
  function togglePlay(video, playBtn) {
    if (video.paused || video.ended) {
      video.play();
      playBtn.style.display = 'none';
    } else {
      video.pause();
	  video.load();
      playBtn.style.display = 'flex';
    }
  }

  let filterType = document.querySelectorAll('.cc__facets-product-type-list');

  if(filterType){
	filterType.forEach(ft=>{
		ft.addEventListener('click', et=>{
			let filter = et.currentTarget.dataset.filter;

			// if(et.currentTarget.classList.contains('cc__facets-pt-active')){
			// 	et.currentTarget.classList.remove('cc__facets-pt-active');
			// } else {
				
			// }


			if(document.querySelector('.cc__facets-pt-active')){
				document.querySelector('.cc__facets-pt-active').classList.remove('cc__facets-pt-active');
			}

			et.currentTarget.classList.add('cc__facets-pt-active');

			window.location.assign('/collections/'+filter+window.location.search);


			// if(filter){
			// 	fetch('/collections/'+filter+search)
			// 	.then((response) => response.text())
			// 	.then((responseText) => {
			// 		const html = new DOMParser().parseFromString(
			// 			responseText,
			// 			"text/html"
			// 		);


			// 		productList.innerHTML = html.getElementById('ProductGridContainer').innerHTML;

			// 		console.log(html.querySelector('script'));


			// 		var scripts = html.querySelectorAll('script');
			// 		for (var i = 0; i < scripts.length; i++) {
			// 			if (scripts[i].innerText) {
			// 			eval(scripts[i].innerText);
			// 			} else {
			// 			fetch(scripts[i].src).then(function (data) {
			// 				data.text().then(function (r) {
			// 				eval(r);
			// 				})
			// 			});

			// 			}
			// 			// To not repeat the element
			// 			scripts[i].parentNode.removeChild(scripts[i]);
			// 		}
			// 	})
			// 	.catch((e) => {
			// 		console.error(e);
			// 	});
			// }
			
			//document.querySelector('input[name="filter.p.product_type"][value="'+filter+'"]').click();
		});
	});
  }


  let filter = document.querySelector('.filter__desktop-selector');

  if( filter){
	filter.addEventListener('click', et=>{
		document.querySelector('.cc__filter-select').classList.toggle('filter__activeselector')
	});
  }